import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UniCommonModule } from './../../../../unifonic-spa-common/src/uni-common.module';
import { PaginationComponent } from './pagination.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [PaginationComponent],
  imports: [
    CommonModule,
    UniCommonModule,
    FormsModule
  ],
  exports: [PaginationComponent]
})
export class PaginationModule { }
